/* eslint-disable */
import React,{useState} from 'react';
import {useNavigate} from "react-router-dom"
import LineChart from '../../../component/Inc/LineChart';
import Tab from '../../../component/Inc/Tab';
import 'contents/assets/scss/page/teacher.scss';
function AssignManageDetail() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"목록으로 보기", value:0},
    {title:"주간으로 보기",  value:1},
  ];
  const navigate = useNavigate();
  const lineChartWidth = "100%";
  const lineChartHeight = "147px";
  //연간 평균 타임수
  const yearlabels = ['2019', '2020', '2021', '2022', '2023'];
  const data = {
    lineChartlabels:yearlabels,
    datasets: [{
      label: "Dataset 1",
      data: [10000, 20000, 40000, 20000, 50000],
      backgroundColor: "#3780ff",
      borderColor: "#d1cdca",
      borderWidth: 1, 
      fill: false,
    }]
  };
  //월간 평균 타임수
  const monthlabels = ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"];
  const dataMonth = {
    lineChartlabels:monthlabels,
    datasets: [{
      label: "Dataset 2",
      data: [10000, 20000, 40000, 20000, 50000, 20000, 30000,10000, 20000, 40000, 20000, 50000, 20000, 30000],
      backgroundColor: '#fc8019',
      borderColor: '#d1cdca',
      borderWidth: 1,
      fill: false,
    }]
  };
  return (
    <main className="com_container p_teacher_assign_manage_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu2_2 active'>
            교사관리
            <span className='bar'></span>
            <span className="point_txt">배정학생 관리 (홍교사103ㆍ수학)</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
        {tabIdx === 0 ? 
        <>
          <div className='box full com_sec_top_card_graph'>
            <article className='wrap'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <div className="com_status_box">
                <div className="item">
                  <p className="tit">희망 수업수</p>
                  <button className='com_btn gray xxs'>수정</button>
                  <p className="num">50</p>
                </div>
                <div className="item">
                  <p className="tit">목표 수업수</p>
                  <button className='com_btn gray xxs'>수정</button>
                  <p className="num">460</p>
                </div>
                <div className="item">
                  <p className="tit">진행 수업수</p>
                  <p className="num">78</p>
                </div>
                <div className="item red">
                  <p className="tit">진행률</p>
                  <p className="num">87.5%</p>
                </div>
              </div>
            </article>
            <article className='wrap'>
              <div className="detail_tit dot">연간 평균 타임 수</div>
              <LineChart
                data={data}
                width={lineChartWidth}
                height={lineChartHeight}
              />
            </article>
            <article className='wrap'>
              <div className="detail_tit dot">월간 평균 타임 수</div>
              <LineChart
                data={dataMonth}
                width={lineChartWidth}
                height={lineChartHeight}
              />
            </article>
          </div>
          <article className='box full'>
            <div className="detail_tit dot">진행중 수업 (42)</div>
            <div className='com_board_list__scroll'>
              <table className='com_board_list'>
                <colgroup>
                  <col width="5.1%"/><col width="6%" />
                  <col width="11%"/><col width="6.5%"/>
                  <col width="6.5%"/><col width="6.5%"/>
                  <col width="8%"/><col width="8%"/>
                  <col width="8%"/><col width="8%"/>
                  <col width="7.5%"/><col width="7.5%"/>
                  <col width="6.6%"/><col width="5.8%"/>
                </colgroup>
                <thead>
                  <tr>
                    <th>학생명</th>
                    <th>수업시간</th>
                    <th>최근 수업 일</th>
                    <th>회차 / T</th>
                    <th>진행 회차</th>
                    <th>기수</th>
                    <th>총 수업료</th>
                    <th>할인</th>
                    <th>실 수업료</th>
                    <th>총 입금 회차</th>
                    <th>총 입금액</th>
                    <th>미 입금액</th>
                    <th>담임</th>
                    <th>수업<br/>히스토리</th>
                  </tr>
                </thead>
                <tbody>
                  {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                  <tr key={idx}>
                    <td>홍길동101</td>
                    <td>60분</td>
                    <td>2023, 05, 10  14:30</td>
                    <td>32/1T</td>
                    <td>12회</td>
                    <td>1기</td>
                    <td>407,000</td>
                    <td>형제할인 2%</td>
                    <td>458,000</td>
                    <td className='td_point'>8.52</td>
                    <td className='td_point'>645,000</td>
                    <td className='td_red'>54,000</td>
                    <td><button className='txt btn_link' onClick={() => navigate("/Teacher/Detail/Info")} >김담임103</button></td>
                    <td className='td_point'>
                      <button className='txt btn_link'>보기</button>
                    </td>
                  </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </article>
          <article className='box full'>
            <div className="detail_tit dot">과거 수업내역 (78)</div>
            <div className='com_board_list__scroll'>
              <table className='com_board_list'>
                <colgroup>
                  <col width="5.7%"/><col />
                  <col width="5.1%"/><col width="8.9%"/>
                  <col width="5.1%"/><col width="5.1%"/>
                  <col width="5.1%"/><col width="5.1%"/>
                  <col width="5.7%"/><col width="5.1%"/>
                  <col width="5.7%"/><col width="5.1%"/>
                  <col width="5.7%"/><col width="4.7%"/>
                  <col width="5.7%"/><col width="4.7%"/>
                </colgroup>
                <thead>
                  <tr>
                    <th>상태</th>
                    <th>학생명</th>
                    <th>수업시간</th>
                    <th>최근 수업 일</th>
                    <th>회차 / T</th>
                    <th>진행 회차</th>
                    <th>기수</th>
                    <th>시수</th>
                    <th>1회 수업료</th>
                    <th>총 수업료</th>
                    <th>할인</th>
                    <th>실 수업료</th>
                    <th>총 입금 회차</th>
                    <th>총 입금액</th>
                    <th>미 입금액</th>
                    <th>담임</th>
                    <th>수업<br/>히스토리</th>
                  </tr>
                </thead>
                <tbody>
                  {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                  <tr key={idx}>
                    <td className='td_red'><span className="txt btn_link">종료</span></td>
                    <td>홍길동101</td>
                    <td>60분</td>
                    <td>2023, 05, 10  14:30</td>
                    <td>32/1T</td>
                    <td>12회</td>
                    <td>1기</td>
                    <td>407,000</td>
                    <td>40,000</td>
                    <td>458,000</td>
                    <td>형제할인 2%</td>
                    <td>458,000</td>
                    <td className='td_point'>8.52</td>
                    <td className='td_point'>645,000</td>
                    <td className='td_red'>54,000</td>
                    <td><button className='txt btn_link' onClick={() => navigate("/Teacher/Detail/Info")} >김담임103</button></td>
                    <td className='td_point'>
                      <button className='txt btn_link'>보기</button>
                    </td>
                  </tr>
                  )
                })}
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </article>
          </>
        : tabIdx === 1 && 
        <>
          <div className='box full'>
            <Tab data={tab} tab={tabIdx} setTab={setTabIdx}  tabStyle="cate"/>
            <div className="com_calendar_wrap">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">전체보기</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">출석만 보기</label>
                <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                <label htmlFor="rdo03">수업 예정 보기</label>
              </div>
              <div className="month">
                <section className="com_tab">
                  <button className="tab active">1주</button><button className="tab ">2주</button><button className="tab ">3주</button><button className="tab ">4주</button><button className="tab ">5주</button>
                </section>
              </div>
              <div className="com_count_wrapper">
                <div className="operators">
                  <div className="operators_label">
                    <span className="operators_count">진행 타임수</span>
                    <span className="operators_value">98</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              달력 영역입니다.
            </div>
          </div>
        </>
        }
        </section>
        
      </div>
    </main>
  );
}

export default AssignManageDetail;
